import { SubscriberItem } from './SubscriberItem';
export class SubscribersReportParam {
    languageId:number;
    entityRegName: string;
    entityRegNumber: string;
    limitedByType: number;
    hTMLTemplate:string;
    subscribers:SubscriberItem[]
}
